export const FileUploadQuery = async (graphqlService, variables, options = {}) => {
    const UPLOAD_FILE_MUTATION = `
            mutation UploadFile($file: Upload!) {
                uploadFile(file: $file) {
                    success
                    url
                    fileName
                    error
                }
            }
        `;
    try {
        const response = await graphqlService.mutateData(UPLOAD_FILE_MUTATION, variables, {
            ...options,
            context: {
                ...options.context,
                fetchOptions: {
                    ...options.context?.fetchOptions,
                    signal: options.context?.fetchOptions?.signal,
                },
            },
        });
        return response;
    } catch (error) {
        if (error.name === 'AbortError') {
            throw new Error('Upload cancelled');
        }
        console.error("Mutation Error:", error);
        throw error;
    }
};